import { FC } from 'react';
import './styles.scss';

type LegendLineProps = {
  name: string;
  value: number;
};

type DistributionGraphLegendProps = {
  min: number;
  mean: number;
  max: number;
  p10: number;
  median: number;
  p90: number;
  p99: number;
  p999: number;
};

const LegendLine: FC<LegendLineProps> = ({ name, value }: LegendLineProps) => (
  <div className="DistributionPage__ExtraInfoValueContainer">
    <div>{name}</div>
    <div>{value}</div>
  </div>
);

const DistibutionGraphLegend: FC<DistributionGraphLegendProps> = ({
  median, min, max, p10, p90, p99, p999, mean,
}: DistributionGraphLegendProps) => (
  <div className="DistributionPage__ExtraInfo">
    <div className="DistributionPage__ExtraInfo--Title">
      Functions
    </div>
    <LegendLine name="Average" value={mean} />
    <LegendLine name="Minimum" value={min} />
    <LegendLine name="Maximum" value={max} />
    <div className="DistributionPage__ExtraInfo--Title">
      Percentiles
    </div>
    <LegendLine name="10th %ile:" value={p10} />
    <LegendLine name="50th %ile:" value={median} />
    <LegendLine name="90th %ile:" value={p90} />
    <LegendLine name="99th %ile:" value={p99} />
    <LegendLine name="99.9th %ile:" value={p999} />

  </div>
);


export default DistibutionGraphLegend;
